import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isShow)
      ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
          key: 0,
          app: "",
          style: {"border-right":"solid 1px #e0e0e0"},
          permanent: ""
        }, {
          default: _withCtx(() => [
            (_ctx.currentCompany)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  nav: "",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMenuItems, (menu, m) => {
                      return (_openBlock(), _createElementBlock("div", { key: m }, [
                        _createVNode(_component_v_list_subheader, { style: {"font-size":"11px","height":"32px","min-height":"32px"} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCompany?.applicationPlan.operationWeb.featureGroups.find(
              (f) => f.name == menu.name
            )?.features, (item, i) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                            key: i,
                            to: menu.features.find((m) => m.slug == item.slug)?.path,
                            target: menu.features.find((m) => m.slug == item.slug)?.target,
                            link: "",
                            density: "compact",
                            "min-height": "32"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                class: "pl-4",
                                style: {"font-size":"13px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["to", "target"])), [
                            [_vShow, item.isEnabled]
                          ])
                        }), 128))
                      ]))
                    }), 128)),
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _createVNode(_component_v_list_item, {
                      onClick: _ctx.logout,
                      density: "compact",
                      "min-height": "32"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, {
                          class: "pl-4",
                          style: {"font-size":"13px"}
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("ログアウト", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}